// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3R-xg","signatureBlock":"Footer_signatureBlock__THRyT","signature":"Footer_signature__115JU"};